import { render, staticRenderFns } from "./FiltersContainer.vue?vue&type=template&id=20ef677e&scoped=true"
import script from "./FiltersContainer.ts?vue&type=script&lang=ts&external"
export * from "./FiltersContainer.ts?vue&type=script&lang=ts&external"
import style0 from "./FiltersContainer.vue?vue&type=style&index=0&id=20ef677e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ef677e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20ef677e')) {
      api.createRecord('20ef677e', component.options)
    } else {
      api.reload('20ef677e', component.options)
    }
    module.hot.accept("./FiltersContainer.vue?vue&type=template&id=20ef677e&scoped=true", function () {
      api.rerender('20ef677e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/NoContract/components/FiltersContainer/FiltersContainer.vue"
export default component.exports